import { useState } from 'react';
export var useTableHeader = function useTableHeader() {
  var initialOrderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'created_at';

  var _useState = useState('desc'),
      headerOrder = _useState[0],
      setHeaderOrder = _useState[1];

  var _useState2 = useState(initialOrderId),
      headerOrderBy = _useState2[0],
      setHeaderOrderBy = _useState2[1];
  /**
   * methods
   */


  var tableHeaderClickAction = function tableHeaderClickAction(event, property) {
    var isSame = headerOrderBy === property;
    setHeaderOrder(isSame ? headerOrder === 'asc' ? 'desc' : 'asc' : headerOrder);
    setHeaderOrderBy(property);
  };

  return {
    headerOrder: headerOrder,
    headerOrderBy: headerOrderBy,
    tableHeaderClickAction: tableHeaderClickAction
  };
};